import { employeeLanguages } from './employee-languages';

import { LanguageCode } from '../../util/languages';

export const languageHasActiveSpeakingEmployees = (
  language: LanguageCode,
  employees: Employee[],
) => {
  const currentEmployees = employees.filter((e) => e.isCurrentEmployee);
  const { languagesToSupport } = employeeLanguages(currentEmployees);
  return languagesToSupport.includes(language);
};
